import type { QuarterFraction } from '@core';
type FractionProps = {
    numerator: QuarterFraction;
};
const DENOMINATOR = 4;

export const QuarterFractions = ({ numerator }: FractionProps) => (
    <>
        <sup>{numerator}</sup>/<sub>{DENOMINATOR}</sub>
    </>
);
